<template>
	<div class="row" style="width: 100px;">
		<router-link tag="a" class="col mr-1 btn btn-secondary" :to="target">Detail</router-link>
		<div class="dropdown">
            <button class="btn btn-secondary" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <a @click="$emit('cancelId', selectedId)" class="dropdown-item" :href="`#${targetModalCancel}`" data-toggle="modal">Batalkan</a>
                <div class="dropdown-divider"></div>
                <button @click="print()" class="dropdown-item" >Cetak QR Code</button>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/plugins/bus.js'

export default {
	name: 'ActionCancelPrintDetail',
	props: ['target', 'selectedId', 'data', 'targetModalCancel', 'targetprint'],
	methods: {
		showModal() {
			let _ = this
			EventBus.$emit('modalDetail'+ this.$route.name, _.data)
		},
		print() {
			let _ = this

            if(localStorage.getItem('bluetooth_print') == 'true') {
                _.axios.get(_.targetprint + '&format=png', {responseType: 'arraybuffer'})
                    .then(resp => {
                        var newBlob = new Blob([resp.data], {type: "image/png"})
                        
                        var reader = new FileReader();
                        reader.readAsDataURL(newBlob);

                        reader.onloadend = function(e) {
                            var imageBase64 = e.target.result.split(',')[1];
                            var intentUrl = "intent://print?package=com.app.bisacekprint&image=" + encodeURIComponent(imageBase64) + "#Intent;scheme=bisacekprint;end";
                            window.location.href = intentUrl;
                        };
                    })
                    .catch(err => {
                        console.log(err.response)
                    })
            }
            else {
                _.axios.get(_.targetprint, {responseType: 'arraybuffer'})
                    .then(resp => {
                        var newBlob = new Blob([resp.data], {type: "application/pdf"})

                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(newBlob);
                            return;
                        } 

                        const data = window.URL.createObjectURL(newBlob);
                        var link = document.createElement('a');
                        link.href = data;
                        link.download = 'QRCODE_' + _.data.no_resi
                        link.click();
                        setTimeout(function(){
                            window.URL.revokeObjectURL(data);
                        }, 100);
                    })
                    .catch(err => {
                        console.log(err.response)
                    })
            }
		},
	}
}
</script>